import React from "react";

import zillowLogo from "./assets/ZillowLogo.svg";
import RentBuySellBlocks from "./components/RentBuySellBlocks";
import * as S from "./styled";

export default function RentBuySellSection() {
  const handleAnalyticsOwnerClick = eventAction => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: eventAction,
      event_label: "click"
    });
  };

  return (
    <S.RentBuySellSectionContainer>
      <S.RentBuySellCardsContainer>
        <RentBuySellBlocks />
      </S.RentBuySellCardsContainer>
      <S.ByOwnerContainer>
        <S.ByOwnerCopy>Want to rent or sell your home yourself?</S.ByOwnerCopy>
        <S.ByOwnerButtonContainer>
          <S.ByOwnerButton
            href="/manage/list_your_rental?click_from=homepage"
            onClick={() => handleAnalyticsOwnerClick("frbo")}
          >
            For Rent By Owner
          </S.ByOwnerButton>
          <S.ByOwnerButton
            href="/manage/list_your_sale?click_from=homepage"
            onClick={() => handleAnalyticsOwnerClick("fsbo")}
          >
            For Sale By Owner
          </S.ByOwnerButton>
        </S.ByOwnerButtonContainer>
      </S.ByOwnerContainer>
      <S.ZillowLogo src={zillowLogo} />
      <S.ZillowLogoText aria-hidden>
        A Zillow Brand built for NYC
      </S.ZillowLogoText>
    </S.RentBuySellSectionContainer>
  );
}
